import React, { createContext, useState } from "react";
import { useMemo } from "react";

export const SiteAndGroupTreeContext = createContext({
  siteSelectedName: "",
  setSiteSelectedName: () => {},
  groupSelectedName: "",
  setGroupSelectedName: () => {},
});

export const SiteAndGroupTreeContextProvider = ({
  children,
}) => {
  const [siteSelectedName, setSiteSelectedName] =
    useState("");
  const [groupSelectedName, setGroupSelectedName] =
    useState("");

  const contextValue = useMemo(() => {
    return {
      siteSelectedName,
      setSiteSelectedName,
      groupSelectedName,
      setGroupSelectedName,
    };
  }, [siteSelectedName, groupSelectedName]);

  return (
    <SiteAndGroupTreeContext.Provider value={contextValue}>
      {children}
    </SiteAndGroupTreeContext.Provider>
  );
};
